export const UPDATE_INSTALL_CODE_PANE_VISIBLE = 'UPDATE_INSTALL_CODE_PANE_VISIBLE';